<a class="sample-link" target="_blank" (click)="logRequestASample()" [href]="requestASampleUrl + '?dpsid=' + gradeId">
  <mat-icon svgIcon="sample"></mat-icon>
  <span i18n="Grade detail request a sample icon@@datatableRequestASample">Request a sample</span>
</a>
<a class="toggle-grade-link" (click)="toggleGrade()" *ngIf="globalData.data?.grades"
  [ngClass]="{ active: getActiveGrade() }">
  <mat-icon svgIcon="polygon-outline"></mat-icon>
  <span i18n="Grade detail add to spider@@gradeDetailAddToSpider">Add to spider chart</span>
</a>